/** User-facing copy for bill scan failures (hide LLM/API details). */
export const BILL_SCAN_ALERT_TITLE = "Couldn't read bill";

export const BILL_SCAN_ALERT_MESSAGE =
  "We couldn't read this receipt. Try a clearer photo with good lighting, or add items manually.";
